import { Link } from 'react-router-dom';
import { DukantiBrandMark } from '@dukanti/shared';
import { useTranslation } from '@dukanti/shared/i18n';
import { RedirectIfAuthed } from '@/components/auth/redirect-if-authed';
import { Button } from '@/components/ui/button';

export function HomeRoute() {
  const { t, dir } = useTranslation();
  return (
    <RedirectIfAuthed>
      <main dir={dir} data-testid="admin-home" className="mx-auto max-w-screen-xl px-6 py-16">
        <div
          data-testid="admin-home-brand"
          className="mb-8 flex items-center gap-3 text-start"
          aria-label="Dukanti"
        >
          <DukantiBrandMark className="size-10 rounded-lg" />
          <span className="text-foreground font-display text-lg font-semibold">Dukanti</span>
        </div>
        <h1 className="font-display text-sand-900 text-start text-4xl">{t('admin.home.hero')}</h1>
        <p className="text-sand-500 mt-2 text-start">{t('admin.home.subhero')}</p>
        <div className="mt-8 flex flex-wrap items-center gap-3">
          <Button asChild data-testid="home-signup-cta">
            <Link to="/auth/signup">{t('admin.home.signUpCta')}</Link>
          </Button>
          <Button asChild variant="outline" data-testid="home-signin-cta">
            <Link to="/auth/signin">{t('admin.home.signInCta')}</Link>
          </Button>
        </div>
      </main>
    </RedirectIfAuthed>
  );
}
